<template>
  <div
    class="vm-nav-header-mobile"
    :class="{'white-bg':
                $route.name == 'feed' ||
                $route.name == 'index' ||
                $route.name == 'explore' ||
                $route.name == 'orderCheck' ||
                $route.name == 'dashboardStats' ||
                $route.name == 'dashboardSponsored-bill' ||
                $route.name == 'dashboardSponsors' ||
                $route.name == 'dashboardIncome' ||
                $route.name == 'dashboardMark' ||
                $route.name == 'dashboardMark-post' ||
                $route.name == 'dashboardOrder' ||
                $route.name == 'dashboardSponsoring' ||
                $route.name == 'oauth2Authorize' ||
                $route.name == 'groupGroupId',
              }">
    <div class="flex-box flex-align-items-center">
      <router-link :to="{ name: 'index' }" class="flex-box flex-align-items-center fs16">
        <img class="logo-img mr16" src="/static/img/logo/logo.png" alt />
        <span class="purple">{{$t('c.NavHeaderMobile.text1')}}</span>
      </router-link>
      <!-- <btn v-if="is_show_download && fr != 'wx'" class="look3 pl8 pr8 fs12 ml16" @click.native="$mixin_router_push('/app')">App下载</btn> -->
      <btn v-if="is_show_download && fr != 'wx' && (GL.ENV.is_wechat && GL.ENV.is_ios)" class="look3 pl8 pr8 fs12 ml16" @click.native="$mixin_open_app">{{$t('c.NavHeaderMobile.text2')}}</btn>
      <wechat-open-app v-else-if="is_show_download && GL.ENV.is_wechat && GL.ENV.is_android" class="ml16"/>
      <btn v-else-if="is_show_download" class="look3 pl8 pr8 fs12 ml16" @click.native="$mixin_open_app">{{$t('c.NavHeaderMobile.text2')}}</btn>
    </div>
    <div class="flex-box flex-align-items-center" v-if="auth_token != -1 && $route.name != 'check'">
      <template v-if="!session_user">
        <router-link v-if="fr != 'wx'" class="search-box flex-box flex-center mr16" to="/search">
          <i class="afd afd-search"></i>
        </router-link>
        <div
          v-if="$route.name != 'login'"
          :to="{ name: 'login' }"
          class="login-door fs14"
          :class="{mr16: $route.name != 'login' && $route.name != 'reg',}"
          @click="jump('login')"
        >{{$t('c.NavHeaderMobile.text3')}}</div>
        <div
          v-if="$route.name != 'reg'"
          :to="{ name: 'reg' }"
          class="fs14 reg-door fwb purple"
          @click="jump('reg')"
        >{{$t('c.NavHeaderMobile.text4')}}</div>
      </template>
      <template v-else>
        <!--<div v-if="is_creator" class="flex-box flex-align-items-center purple" @click="show_modal_feed">-->

        <!--<btn>-->
        <!--<i class='afd afd-plus'></i><span class='ml8'>发布</span>-->
        <!--</btn>-->
        <!--</div>-->
        <!--<router-link v-else to="/apply" class="flex-box flex-align-items-center purple">-->
        <!--成为创作者-->
        <!--</router-link>-->
        <router-link v-if="$route.name != 'explore' && fr != 'wx'" class="search-box flex-box flex-center" to="/search">
          <i class="afd afd-search"></i>
        </router-link>
        <nav-menu-mobile v-if="session_user && fr != 'wx'" class="ml24" :is_icon_avatar="mixin_is_nav_icon_avatar"></nav-menu-mobile>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "nav-header-mobile",
  props: {},
  watch:{
    $route(v){
      this.fr = v.query.fr
    }
  },
  data() {
    return {
      fr: '',
    };
  },
  computed: {
    ...mapState("app", [
      "session_user",
      "user_status",
      "auth_token",
      "unread_message_num",
      "is_show_download"
    ]),
    is_creator() {
      if (
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.status
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
  },
  methods: {
    jump(name){
        let n = this.$route.name
        if(n != 'login' && n != 'reg'){ //防止这两个页面来回跳
            this.$store.commit('app/set:redirect_url', this.$route.fullPath);
        }
        this.$router.push({name});
    },
  }
};
</script>
<style lang="stylus" scoped>
.vm-nav-header-mobile {
  height: $nav-mobile-height;
  padding: 0 px2rem(16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 20;
  background: $white-bg;

  // border-bottom 1px solid $black-1
  &.white-bg {
    background: $white;
  }

  .logo-img {
    width: px2rem(30);
  }

  .search-box {
    width: px2rem(24);
    height: px2rem(24);
  }
}
</style>
